export const StaticFileType = {
  Vpp: 0
} as const

export type StaticFileType = typeof StaticFileType[keyof typeof StaticFileType]
